import React from 'react';
import ProfileImage from '../../Header/ProfileImage';
import { Tooltip } from '@mui/material';

interface CollaboratorBadgeProps {
  collaborator: {
    name: string;
    avatarURL?: string | null;
    avatar_url?: string | null;
    profile_picture?: string | null;
    initials: string;
    email?: string | null;
    active?: string;
    access?: string;
  };
}

export const getInitials = (name?: string | null) => {
  if (!name || typeof name !== 'string') return 'U';
  const parts = name.trim().split(' ').filter(p => p.length > 0);
  if (parts.length === 0) return 'U';
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};

const accessDisplayLabel = (access?: string): string => {
  if (!access) return '';
  if (access.toLowerCase() === 'admin') return 'Owner';
  return access.charAt(0).toUpperCase() + access.slice(1);
};

const CollaboratorBadge: React.FC<CollaboratorBadgeProps> = ({ collaborator }) => {
  const tooltipText = collaborator.access
    ? `${collaborator.name} · ${accessDisplayLabel(collaborator.access)}`
    : collaborator.name;

  return (
    <Tooltip title={tooltipText}>
    <div
     className={`relative rounded-full ${
      collaborator.active
        ? "border-2 border-green-500"
        : "border-2 border-transparent"
    }`}
    >
      <ProfileImage
        profilePicture={(collaborator.avatarURL || collaborator.avatar_url || collaborator.profile_picture || null) as string}
        email={collaborator.email as string}
        initials={collaborator.initials}
      />
    </div>
        </Tooltip>
  );
};

export default CollaboratorBadge;
